import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	applications: [],
	loading: false
};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_APPLICATIONS_REQUEST:
		case ActionTypes.GET_APPLICATIONS_ERROR:
		case ActionTypes.GET_APPLICATIONS_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_APPLICATIONS_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_APPLICATIONS_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
